import React, {useState} from 'react';
import HeaderMenuDropdown from './HeaderMenuDropdown';

/**
 * Komponent reprezentujący pojedynczy element menu.
 *
 * @param {object} item - Obiekt reprezentujący element menu.
 * @param {number} depth - Obecny poziom zagnieżdżenia.
 * @param isMobile
 * @returns {JSX.Element}
 */
const HeaderMenuItem = ({item, depth, isMobile}) => {
    const hasChildren = item.children && item.children.length > 0;
    const [isOpen, setIsOpen] = useState(false);
    const isServicesMenu = item.classes && item.classes.includes('services-menu');

    const handleMouseEnter = (e) => {

        if (hasChildren) {
            if(isServicesMenu){
                const submenu = e.currentTarget.querySelector('.submenu-wrapper');
                if (submenu) submenu.classList.add('open');
            }
            else{
                const submenu = e.currentTarget.querySelector('.submenu.depth-1');
                if (submenu) submenu.classList.add('open');
            }
        }
    };

    const handleMouseLeave = (e) => {
        if(isServicesMenu){
            const submenu = e.currentTarget.querySelector('.submenu-wrapper');
            if (submenu) submenu.classList.remove('open');
        }
        else{
            const submenu = e.currentTarget.querySelector('.submenu.depth-1');
            if (submenu) submenu.classList.remove('open');
        }
    };

    const handleSubmenuClick = (e) => {
        if (isMobile && hasChildren) {
            e.preventDefault();
            const dataOpen = e.currentTarget.getAttribute('data-open');
            const submenu = document.querySelector(`ul.submenu[data-parent="${dataOpen}"]`);

            if (submenu) {

                const allSubmenus = document.querySelectorAll(`ul.submenu.depth-2.open`);
                allSubmenus.forEach((menu) => {
                    if (menu !== submenu) {
                        menu.classList.remove('open');
                    }
                });

                const allOpenSpans = document.querySelectorAll('.depth-1 span.open-submenu');
                allOpenSpans.forEach((spanElement) => {
                    spanElement.classList.remove('open');
                });

                const isCurrentlyOpen = submenu.classList.contains('open');
                submenu.classList.toggle('open', !isCurrentlyOpen);

                e.currentTarget.classList.toggle('open', !isCurrentlyOpen);
            }
        }
    };


    return (
        <li
            id={`${item.item_id}`}
            className={[
                'menu-item',
                ...(item.classes || []), // Dodanie klas z obiektu item
                hasChildren ? 'has-children' : '', // Klasa, jeśli ma dzieci
                !isServicesMenu && hasChildren && depth === 0 ? 'standard-submenu' : '' // Klasa, jeśli nie jest `services-menu`, ale ma dzieci
            ]
                .filter(Boolean) // Usunięcie pustych wartości
                .join(' ')} // Łączenie klas w jeden string
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <a className={`nav-item depth-${depth}`} href={item.href} aria-label={item.name}>
                {item.name}
            </a>
            {hasChildren && (
                <span
                    className="open-submenu"
                    data-open={item.item_id}
                    onClick={handleSubmenuClick}
                ></span>
            )}
            {hasChildren && (
                <HeaderMenuDropdown
                    items={item.children}
                    depth={depth + 1}
                    parentId={item.item_id}
                    isMobile={isMobile}
                    isServicesMenu={isServicesMenu}
                />
            )}
        </li>
    );
};

export default HeaderMenuItem;
